var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 12.7656H8.33301M3.33301 12.7656C3.33301 17.7362 7.36244 21.7656 12.333 21.7656M3.33301 12.7656C3.33301 7.79506 7.36244 3.76562 12.333 3.76562M8.33301 12.7656H16.333M8.33301 12.7656C8.33301 17.7362 10.1239 21.7656 12.333 21.7656M8.33301 12.7656C8.33301 7.79506 10.1239 3.76562 12.333 3.76562M16.333 12.7656H21.333M16.333 12.7656C16.333 7.79506 14.5421 3.76562 12.333 3.76562M16.333 12.7656C16.333 17.7362 14.5421 21.7656 12.333 21.7656M21.333 12.7656C21.333 7.79506 17.3036 3.76562 12.333 3.76562M21.333 12.7656C21.333 17.7362 17.3036 21.7656 12.333 21.7656",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globeIcon.fb7690e8890a213b08afb7fd665250a6.svg";
export { ForwardRef as ReactComponent };